var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup35(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 155.337,
    height: 106.781,
    viewBox: "0 0 155.337 106.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35",
    transform: "translate(-903.275 -1600.233)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M2110.152,613.531a3.207,3.207,0,0,1,3.88,4.885c-19.438,24.751-68.452,85.334-68.452,85.334a8.916,8.916,0,0,1-13.3.555l-28.917-29.855c-.093-.092-.185-.184-.277-.277a.044.044,0,0,0-.027-.013l-2.642-2.739a4.65,4.65,0,0,1,1.384-7.443Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1997.34,676.957l-6.3,2.708a1.676,1.676,0,0,1-2.267-2.019l2.1-7.051a1.676,1.676,0,0,1,2.812-.685l4.2,4.343a1.676,1.676,0,0,1-.544,2.7",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1990.425,663.43l-.158.066a1.82,1.82,0,0,0-.344.2,2.61,2.61,0,0,0-.3.238,1.027,1.027,0,0,0-.172.171,2.565,2.565,0,0,0-.62,1.122l-4.619,15.442a.481.481,0,0,1-.594.409.664.664,0,0,1-.211-.053.509.509,0,0,1-.317-.449l-2.738-22.244a4.479,4.479,0,0,1,2.861-4.736s66.245-26.363,103.433-40.19a2.659,2.659,0,0,1,2.049,4.9c-34.948,16.311-98.267,45.124-98.267,45.124",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M2099.89,603.8l-117.743,44.546a7.3,7.3,0,0,1-7.767-1.689L1962,634.157a8.88,8.88,0,0,1,5.055-15.086s93.833-13.515,131.936-18.813a1.838,1.838,0,0,1,.9,3.54",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup35);
export default __webpack_public_path__ + "static/media/Group 35.a4c7b17aa95e69b71b05ffb2261d652b.svg";
export { ForwardRef as ReactComponent };